"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencyString = void 0;
var formatCurrencyAmountToString = function (number, currencyDecimals) {
    if (currencyDecimals === void 0) { currencyDecimals = 2; }
    if (number === undefined || number === null) {
        throw Error('number is required');
    }
    return parseFloat(parseFloat(number).toFixed(currencyDecimals)).toLocaleString(undefined, {
        minimumFractionDigits: currencyDecimals,
        maximumFractionDigits: currencyDecimals,
    });
};
var getCurrencyString = function (_a) {
    var amount = _a.amount, currency = _a.currency, currencyDecimals = _a.currencyDecimals;
    if (amount === undefined) {
        throw Error('amount is required');
    }
    if (!currency === undefined) {
        throw Error('currency is required');
    }
    return "".concat(formatCurrencyAmountToString(amount, currencyDecimals), " ").concat(currency);
};
exports.getCurrencyString = getCurrencyString;
//# sourceMappingURL=formatter.js.map